import React, { useState, useEffect, useRef } from "react";

const DropdownSelect = ({
  options = [],
  placeholder = "",
  labelKey = "title",
  currentOption,
  setCurrentOption,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className="tw-max-w-full ">
      <div className="tw-relative">
        <div
          onClick={() => setIsOpen(!isOpen)}
          className="tw-h-10 tw-bg-white tw-flex tw-border tw-border-gray-200 tw-rounded tw-items-center"
        >
          <input
            placeholder={placeholder}
            value={currentOption[labelKey] || ""}
            name="select"
            id="select"
            className="tw-appearance-none tw-outline-none tw-text-gray-800 tw-w-full tw-border-none tw-p-0 tw-px-2"
            readOnly
          />
          <button
            onClick={(e) => {
              e.stopPropagation();
              setCurrentOption("");
            }}
            className="tw-w-1 tw-p-0 tw-pe-3 tw-text-[18px] tw-cursor-pointer material-icons tw-outline-none tw-focus:outline-none tw-transition-all tw-text-gray-300 hover:tw-text-gray-600"
          >
            close
          </button>
          <label
            htmlFor="show_more"
            className="tw-cursor-pointer tw-my-2 tw-px-1 material-icons tw-outline-none tw-focus:outline-none tw-border-l tw-border-gray-200 tw-transition-all tw-text-gray-300 hover:tw-text-gray-600"
          >
            {isOpen ? (
              <span className="material-symbols-outlined">
                keyboard_arrow_up
              </span>
            ) : (
              <span className="material-symbols-outlined">
                keyboard_arrow_down
              </span>
            )}
          </label>
        </div>

        {isOpen && (
          <div className="tw-absolute tw-z-50 tw-rounded tw-shadow tw-bg-white tw-overflow-hidden tw-flex tw-flex-col tw-w-full tw-mt-1 tw-border tw-border-gray-200">
            {options.map((option, index) => (
              <div
                key={index}
                className="tw-cursor-pointer tw-group"
                onClick={() => {
                  setCurrentOption(option);
                  setIsOpen(false);
                }}
              >
                <div className="tw-block tw-p-2 tw-border-transparent tw-border-l-4 group-hover:tw-border-blue-600 group-hover:tw-bg-gray-100">
                  {option?.[labelKey]}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DropdownSelect;
